exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.editor {\n  font-style: normal;\n  font-size: 90%;\n  font-weight: normal;\n  margin-bottom: 0.5em;\n  display: block;\n  color: white\n}\n\nbutton {\n  margin-top: 0.6ex;\n  background: silver;\n  border: black;\n  width: 90px;\n  font-family: Oxygen;\n  border-radius: 6px;\n  padding-bottom: 5px;\n  padding-top: 3px;\n  text-transform: uppercase;\n  cursor: pointer\n}\n\nbutton.logout:after {\n  content: \" \\274C\";\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/login-box/login-box.component.css
// module id = ../../../../../src/app/login-box/login-box.component.css
// module chunks = main